import { Button, Group, Modal } from '@economic/gaudi';
import React, { Dispatch, SetStateAction } from 'react';
import { t } from '../../../../../../../shared/components/l10n/l10n';
import { ProgressDots } from '../../../../../../../shared/components/ui/progressDots/ProgressDots';
import ErrorOnboardingIllustration from '../../../assets/Error-onboarding.png';

interface Props {
    totalSteps: number;
    errorMessage?: string;
    setErrorMessage: Dispatch<SetStateAction<string | undefined>>;
    back: () => void;
    onModalClose: () => void;
}

const ErrorStep = ({ totalSteps, errorMessage, setErrorMessage, back, onModalClose }: Props) => {
    const onBackClicked = () => {
        setErrorMessage(undefined);
        back();
    };

    return (
        <>
            <Modal.Header>
                <ProgressDots stepsCount={totalSteps} currentStep={4} withCompleteTicks={false} />
                <img src={ErrorOnboardingIllustration} alt="Error onboaring illustration" className="w-48 my-6 mx-auto" />
                <div className="my-4">{t`SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_TITLE`}</div>
            </Modal.Header>

            <Modal.Content>
                <div className="flex flex-col items-center modal_informationSent--content">
                    <span>{errorMessage}</span>
                </div>
            </Modal.Content>

            <Modal.Footer>
                <Group>
                    <Button onClick={onBackClicked}>{t`SMARTPAY_ONBOARDING_MODAL_BACK_BUTTON`}</Button>
                    <Button autoFocus appearance="primary" onClick={onModalClose}>
                        {t`SMARTPAY_ONBOARDING_MODAL_CONSENT_CLOSE_BUTTON`}
                    </Button>
                </Group>
            </Modal.Footer>
        </>
    );
};

export default ErrorStep;
